<template>
  <div class="container py-4">
    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center mb-4">
      <div>
        <h2 class="mb-1">Verbrauchsanalyse</h2>
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'teams-list' }" class="text-decoration-none">
                Bereiche
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link
                :to="{ name: 'teams-detail', params: { id: $route.params.id } }"
                class="text-decoration-none"
              >
                Quittungsverwaltung
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link
                :to="{ name: 'teams-settings', params: { id: $route.params.id } }"
                class="text-decoration-none"
              >
                Bereich-Einstellungen
              </router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Verbrauchsanalyse</li>
          </ol>
        </nav>
      </div>
      <div class="d-flex gap-2">
        <button class="btn btn-outline-secondary" @click="goBack">
          <font-awesome-icon icon="arrow-left" /> Zurück
        </button>
      </div>
    </div>

    <!-- Admin Check -->
    <div v-if="!isAdminOrCreator" class="alert alert-gradient-warning" role="alert">
      <font-awesome-icon icon="exclamation-triangle" class="me-2" />
      Du hast keine Berechtigung, die Verbrauchsanalyse einzusehen. Nur Bereich-Administratoren und Bereich-Ersteller können diese Daten einsehen.
    </div>

    <!-- Consumption Analysis -->
    <div v-else class="card">
      <div class="card-body">
        <CoinConsumptionHistory 
          v-if="selectedTeam"
          :team-id="selectedTeam.id"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useAuthStore } from '@/stores/auth'
import { useTeamsStore } from '@/stores/teams'
import CoinConsumptionHistory from '@/components/coins/CoinConsumptionHistory.vue'

const router = useRouter()
const route = useRoute()
const teamsStore = useTeamsStore()
const authStore = useAuthStore()
const { selectedTeam } = storeToRefs(teamsStore)
const currentUser = computed(() => authStore.user)

const isAdminOrCreator = computed(() => {
  if (!selectedTeam.value || !currentUser.value) return false
  return (
    selectedTeam.value.role === 'teamAdmin' || 
    selectedTeam.value.creatorId === currentUser.value.id
  )
})

const goBack = () => {
  router.push({ name: 'teams-settings', params: { id: route.params.id } })
}

onMounted(async () => {

  if (!selectedTeam.value || selectedTeam.value.id !== route.params.id) {
    await teamsStore.loadTeamById(route.params.id)
  }
})
</script>
